import { useEffect, useRef } from 'react';

const useUpdateEffect = (callback, deps) => {
  const isFirstEffectRef = useRef(true);

  useEffect(() => {
    if (isFirstEffectRef.current) {
      isFirstEffectRef.current = false;
      return undefined;
    }

    return callback();
  }, deps);
};

export default useUpdateEffect;
